import * as style from './styles.css';
import { clsx } from 'clsx';
import { Button, useDeviceType } from '@cian/ui-kit';
import { EModalSource } from 'shared/common/types/modal';
import { getHowItWorks } from 'shared/landingBuyer/containers/HowItWorksContainer/constants';
import { NBSP } from '../../../common/constants/symbols';
import { IApplicationContext } from '../../../common/types/applicationContext';

export const HowItWorks: React.FC<{
  onOpenModal: (EModalSource: string) => void;
  context: IApplicationContext['custom'];
}> = ({ onOpenModal, context }) => {
  const device = useDeviceType();
  const isMobile = device === 'phone';
  const howItWorks = getHowItWorks(context);

  return (
    <>
      <div className={clsx(style['container'], style[device])}>
        <div className={style['title']}>Пройдём с вами весь путь</div>
        <div className={style['list']}>
          {howItWorks.map(({ id, title, description, imageClass, link }) => (
            <div key={id} className={clsx(style['item'], style[device])}>
              <div className={style['item-textblock']}>
                <div className={style['item-id']}>{id}</div>
                <div className={style['item-title']}>{title}</div>
                <div className={style['item-descr']}>{description}</div>
                {link && <div className={style['item-link']}>{link}</div>}
              </div>
              <div className={clsx(style['item-image'], style[imageClass], style[device])} />
            </div>
          ))}
        </div>
      </div>
      <div className={clsx(style['notice-wrapper'], style[device])}>
        <div className={style['notice']}>
          <div className={clsx(style['map-icon'])} />
          <div>
            <div className={style['notice-title']}>Без скрытых комиссий</div>

            <div className={style['notice-descr']}>
              {isMobile ? (
                `Вы платите только агенту и${NBSP}только заранее обговорённую${NBSP}сумму`
              ) : (
                <>
                  Вы платите только агенту
                  <br />и только заранее обговорённую сумму
                </>
              )}
            </div>
          </div>
        </div>
        <div className={style['button']}>
          <Button
            size="L"
            fullWidth={device !== 'desktop' && device !== 'tablet'}
            onClick={() => onOpenModal(EModalSource.Consultation)}
          >
            Расскажите ещё подробнее
          </Button>
        </div>
      </div>
    </>
  );
};
